import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import { feeSchedulePrograms as fspUtils } from '@unite-us/client-utils';
import DollarAmount from '../DollarAmount';
import LineItem from '../../pages/builder/LineItem';
import { formatShortDateFromTimestamp } from './formatShortDate';
var ReferralAuthorizationRequestSummary = function ReferralAuthorizationRequestSummary(_ref) {
  var authorizationRequest = _ref.authorizationRequest,
    feeScheduleProgram = _ref.feeScheduleProgram;
  var service_start = authorizationRequest.service_start,
    service_end = authorizationRequest.service_end,
    amount_requested = authorizationRequest.amount_requested,
    icd10_code = authorizationRequest.icd10_code;
  var isCostBased = fspUtils.isCostPaymentType(feeScheduleProgram === null || feeScheduleProgram === void 0 ? void 0 : feeScheduleProgram.payment_type);
  var isSingleDateRequested = service_start && !service_end;
  var showUnits = !isCostBased && (feeScheduleProgram === null || feeScheduleProgram === void 0 ? void 0 : feeScheduleProgram.unit);
  var showRate = showUnits && (feeScheduleProgram === null || feeScheduleProgram === void 0 ? void 0 : feeScheduleProgram.unit_rate) > 0;
  var fieldClassName = "text-brand-blue text-sm font-bold leading-5 break-word";
  return /*#__PURE__*/React.createElement("dl", {
    className: "grid grid-cols-line-items gap-x-24 gap-y-2"
  }, /*#__PURE__*/React.createElement(LineItem, {
    field: "Contracted Program",
    fieldClassName: fieldClassName,
    dataTestElement: "request-contracted-program"
  }, feeScheduleProgram.name), /*#__PURE__*/React.createElement(LineItem, {
    field: "Payment Approach",
    fieldClassName: fieldClassName,
    dataTestElement: "request-payment-approach"
  }, fspUtils.PAYMENT_TYPES[feeScheduleProgram.payment_type]), showUnits && /*#__PURE__*/React.createElement(LineItem, {
    field: "Unit",
    fieldClassName: fieldClassName,
    dataTestElement: "request-unit"
  }, /*#__PURE__*/React.createElement("span", {
    className: "capitalize"
  }, feeScheduleProgram.unit)), showRate && /*#__PURE__*/React.createElement(LineItem, {
    field: "Rate",
    fieldClassName: fieldClassName,
    dataTestElement: "request-rate"
  }, /*#__PURE__*/React.createElement(DollarAmount, {
    value: feeScheduleProgram.unit_rate,
    convertCents: true
  }), ' per ', feeScheduleProgram.unit), feeScheduleProgram.cap_information && /*#__PURE__*/React.createElement(LineItem, {
    field: "Program Cap",
    fieldClassName: fieldClassName,
    dataTestElement: "request-cap"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: feeScheduleProgram.cap_information
    }
  })), /*#__PURE__*/React.createElement(LineItem, {
    field: "Amount Requested",
    fieldClassName: fieldClassName,
    dataTestElement: "amount-requested"
  }, isCostBased ? /*#__PURE__*/React.createElement(DollarAmount, {
    value: amount_requested,
    convertCents: true
  }) : "".concat(amount_requested, " ").concat(pluralize(feeScheduleProgram.unit, amount_requested))), isSingleDateRequested ? /*#__PURE__*/React.createElement(LineItem, {
    field: "Service Delivery Date",
    fieldClassName: fieldClassName,
    dataTestElement: "request-service-delivery-date"
  }, formatShortDateFromTimestamp(service_start)) : /*#__PURE__*/React.createElement(LineItem, {
    field: "Service Delivery Dates",
    fieldClassName: fieldClassName,
    dataTestElement: "request-service-delivery-dates"
  }, formatShortDateFromTimestamp(service_start), " - ", formatShortDateFromTimestamp(service_end)), feeScheduleProgram.cm_code_required_on_authorization && /*#__PURE__*/React.createElement(LineItem, {
    field: "ICD-10 Code",
    fieldClassName: fieldClassName,
    dataTestElement: "icd10-code"
  }, /*#__PURE__*/React.createElement("span", {
    className: "capitalize"
  }, icd10_code.value)));
};
ReferralAuthorizationRequestSummary.propTypes = {
  authorizationRequest: PropTypes.object.isRequired,
  feeScheduleProgram: PropTypes.object.isRequired
};
export default ReferralAuthorizationRequestSummary;
//# sourceMappingURL=ReferralAuthorizationRequestSummary.js.map